import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalService } from '../providers/global.service';
import { RequestService } from '../providers/request/request.service';
import { ArchiveFileAttach } from '../models/archive/archive-file-attach.model';

@Injectable({
  providedIn: 'root',
})
export class ArchiveFileAttachService extends RequestService<ArchiveFileAttach> {
  static PATH = '/archive/file/attach';
  constructor(
    public override httpClient: HttpClient,
    private globalService: GlobalService
  ) {
    super(httpClient, ArchiveFileAttachService.PATH, globalService.debugUrl);
  }
}
